<template>
  <!-- 小工具箱 -->
  <div class="toolbox-page">
    <!-- 顶部横幅 -->
    <div class="hero">
      <div class="hero-left">
        <div class="hero-badge"><span class="dot"></span>小工具箱 · {{ tools.length }} 个工具</div>
        <h1>效率小工具 <span>合集</span></h1>
        <p>把日常高频、零散的操作收拢到这里，一键直达。支持搜索。</p>
        <div class="hero-actions">
          <el-input v-model="keyword" placeholder="搜索工具，如：删除 / 追加 / 素材" clearable class="search" :prefix-icon="Search"
            @input="currentPage = 1" />
          <!-- <el-button type="primary" :icon="Plus" @click="tipAdd">提需求</el-button> -->
        </div>
      </div>
      <div class="hero-right">
        <div class="stat-card" v-for="s in stats" :key="s.label">
          <div class="stat-num">{{ s.value }}</div>
          <div class="stat-label">{{ s.label }}</div>
        </div>
      </div>
    </div>

    <!-- 分类 -->
    <div class="cats">
      <el-segmented v-model="activeCat" :options="catOptions" size="default" />
      <span class="count">共 {{ filtered.length }} 个</span>
    </div>

    <!-- 工具卡片 -->
    <div class="grid">
      <div v-for="t in paged" :key="t.key" class="tool-card" :style="{ '--c': t.color }" @click="runTool(t)">
        <div class="card-top">
          <div class="icon" :style="{ background: t.color + '1a', color: t.color }"><el-icon :size="22">
              <component :is="t.icon" />
            </el-icon></div>
          <div class="tags"><el-tag v-for="tag in t.tags" :key="tag" size="small" effect="plain" round>{{ tag
              }}</el-tag></div>
        </div>
        <h3 class="title">{{ t.title }}</h3>
        <p class="desc">{{ t.desc }}</p>
        <div class="foot">
          <span class="meta"><span class="meta-txt">{{ t.meta }}</span></span>
          <span class="use-btn" :style="{ '--c': t.color }" @click.stop="runTool(t)">去使用<el-icon class="go">
              <ArrowRight />
            </el-icon></span>
        </div>
      </div>
      <el-empty v-if="!filtered.length" class="empty-block" description="没找到相关工具，换个关键词试试" />
    </div>

    <div class="pager" v-if="filtered.length > pagesize">
      <el-pagination background layout="prev, pager, next" :page-size="pagesize" :total="filtered.length"
        v-model:current-page="currentPage" />
    </div>

    <!-- 批量删除巨量素材弹窗 -->
    <el-dialog v-model="deleteVideoVisible" title="批量删除巨量素材" width="80%" top="5vh" destroy-on-close>
      <ylyDeleteVideoTool v-if="deleteVideoVisible" @cancel="deleteVideoVisible = false"
        @success="deleteVideoSuccess" />
    </el-dialog>

    <!-- 批量上传头像弹窗 -->
    <el-dialog v-model="headerUploadVisible" title="批量上传头像" width="70%" top="5vh" destroy-on-close>
      <ylyHeaderImageUpload v-if="headerUploadVisible" @cancel="headerUploadVisible = false"
        @success="headerUploadSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { Search, Plus, Delete, UploadFilled, ArrowRight, MagicStick, DataAnalysis, Picture, Link, Goods, Avatar, VideoPlay } from '@element-plus/icons-vue'
import pagination from '@/components/pagination.vue'
import ylyDeleteVideoTool from '@/components/ylyBatch/ylyDeleteVideoTool.vue'
import ylyHeaderImageUpload from '@/components/ylyBatch/ylyHeaderImageUpload.vue'

const iconMap = { Delete, UploadFilled, MagicStick, DataAnalysis, Picture, Link, Goods, Avatar, VideoPlay }

export default {
  name: 'smallTools',
  components: { pagination, ylyDeleteVideoTool, ylyHeaderImageUpload, Delete, UploadFilled, MagicStick, DataAnalysis, Picture, Link, Goods, Avatar, VideoPlay, ArrowRight },
  setup() {
    const state = reactive({
      keyword: '',
      activeCat: '全部',
      catOptions: ['全部', '素材管理', '项目投放', '数据分析', '常用链接'],
      pagesize: 8,
      currentPage: 1,
      total: 100,
      deleteVideoVisible: false,
      headerUploadVisible: false,
      tools: [
        { key: 'del-video', title: '批量删除巨量素材', desc: '按条件批量筛选并删除巨量已上传素材。', tags: ['巨量', '批量'], meta: '', color: '#f56c6c', icon: 'Delete', cat: '素材管理', action: 'delVideo' },
        { key: 'r3-add', title: '全域项目追加素材', desc: '为全域/R3项目一键追加视频素材，新开页签操作，不打断当前流程。', tags: ['全域', 'R3'], meta: '新开页签 · 秒达', color: '#409eff', icon: 'UploadFilled', cat: '项目投放', action: 'r3add' },
        { key: 'fanqie-pl-pd', title: '巨量番茄批量生成链接和商品', desc: '批量生成番茄推广链接与商品，新开页签操作，不打断当前流程。', tags: ['巨量', '番茄', '批量'], meta: '新开页签 · 秒达', color: '#67c23a', icon: 'Goods', cat: '常用链接', action: 'fanqieplpd' },
        // { key: 'playlet-batch', title: '手动铺剧', desc: '手动铺排/管理短剧信息，新开页签操作，不打断当前流程。', tags: ['短剧', '批量'], meta: '新开页签 · 秒达', color: '#9254de', icon: 'VideoPlay', cat: '项目投放', action: 'playlet' },
        // { key: 'header-upload', title: '批量上传巨量账户头像', desc: '选择开发者账户批量上传巨量账号头像，不打断当前流程。', tags: ['巨量', '开发者', '头像', '批量'], meta: '弹窗操作 · 秒达', color: '#e6a23c', icon: 'Avatar', cat: '常用链接', action: 'headerUpload' },
        // 预留示例：后续加工具只加一行配置即可
        // { key: 'more-1', title: '敬请期待 · 素材去重', desc: '占位卡片：后续新工具直接在 tools 数组追加即可自动上架。', tags: ['规划中'], meta: '即将上线', color: '#909399', icon: 'MagicStick', cat: '素材管理', action: '' },
        // { key: 'more-2', title: '敬请期待 · 数据速查', desc: '占位卡片：可放报表、链接、脚本入口等轻量工具。', tags: ['规划中'], meta: '即将上线', color: '#909399', icon: 'DataAnalysis', cat: '数据分析', action: '' },
      ],
      openDeleteVideoDialog: () => { state.deleteVideoVisible = true },
      deleteVideoSuccess: () => { state.deleteVideoVisible = false; ElMessage.success('删除成功') },
      openHeaderUploadDialog: () => { state.headerUploadVisible = true },
      headerUploadSuccess: () => { state.headerUploadVisible = false; ElMessage.success('上传成功') },
      R3addvideoFun: () => { window.open('ylyProjectAddVideo', '_blank') },
      // 巨量番茄批量生成链接和商品：新开页签
      fanqiePLPDFun: () => { window.open('ylyPLPromotionAndProduct', '_blank') },
      // 手动铺剧：新开页签
      playletBatchFun: () => { window.open('ylyPlayletBatchManage', '_blank') },
      tipAdd: () => { ElMessage.info('在 tools 数组加一行配置即可上架新工具～') },
      runTool: (t) => {
        if (t.action === 'delVideo') state.openDeleteVideoDialog()
        else if (t.action === 'r3add') state.R3addvideoFun()
        else if (t.action === 'fanqieplpd') state.fanqiePLPDFun()
        else if (t.action === 'playlet') state.playletBatchFun()
        else if (t.action === 'headerUpload') state.openHeaderUploadDialog()
        else ElMessage.info('该工具尚未上线')
      },
    })

    const filtered = computed(() => {
      const kw = state.keyword.trim()
      return state.tools.filter((t) => {
        const hitCat = state.activeCat === '全部' || t.cat === state.activeCat
        const hitKw = !kw || (t.title + t.desc + t.tags.join('')).toLowerCase().includes(kw.toLowerCase())
        return hitCat && hitKw
      })
    })
    const paged = computed(() => {
      const s = (state.currentPage - 1) * state.pagesize
      return filtered.value.slice(s, s + state.pagesize)
    })
    const stats = computed(() => [
      // { label: '已上架工具', value: state.tools.filter((t) => t.action).length },
      // { label: '覆盖分类', value: new Set(state.tools.map((t) => t.cat)).size },
      // { label: '规划中', value: state.tools.filter((t) => !t.action).length },
    ])

    return { ...toRefs(state), filtered, paged, stats, Search, Plus, ArrowRight }
  },
}
</script>

<style lang="scss" scoped>
.toolbox-page {
  padding: 16px;
  min-height: calc(100vh - 120px);
  background: #f5f7fa;
  border-radius: 12px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.hero {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  background: linear-gradient(135deg, #2b4bff 0%, #6a5cff 60%, #8b5cf6 100%);
  border-radius: 16px;
  padding: 24px 28px;
  color: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(64, 90, 255, .22);
}

.hero::after {
  content: '';
  position: absolute;
  width: 380px;
  height: 380px;
  right: -120px;
  top: -170px;
  background: radial-gradient(circle, rgba(255, 255, 255, .22), transparent 65%);
  pointer-events: none;
}

.hero-left {
  position: relative;
  z-index: 1;
  min-width: 0;
  flex: 1;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, .18);
  border: 1px solid rgba(255, 255, 255, .3);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3dff9e;
  box-shadow: 0 0 8px #3dff9e;
  flex-shrink: 0;
}

.hero h1 {
  margin: 10px 0 6px;
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: 1px;
}

.hero h1 span {
  color: #ffe58a;
}

.hero p {
  opacity: .88;
  font-size: 13px;
  margin: 0 0 14px;
  max-width: 560px;
  line-height: 1.6;
}

.hero-actions {
  display: flex;
  gap: 10px;
  position: relative;
  z-index: 2;
  max-width: 520px;
}

.hero-actions .el-button {
  flex-shrink: 0;
}

.search {
  flex: 1;
  min-width: 0;

  :deep(.el-input__wrapper) {
    border-radius: 20px;
  }
}

.hero-right {
  display: flex;
  gap: 12px;
  align-items: center;
  z-index: 1;
  flex-shrink: 0;
}

.stat-card {
  background: rgba(255, 255, 255, .16);
  border: 1px solid rgba(255, 255, 255, .25);
  border-radius: 12px;
  padding: 12px 18px;
  text-align: center;
  min-width: 88px;
}

.stat-num {
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
}

.stat-label {
  font-size: 12px;
  opacity: .85;
  white-space: nowrap;
}

.cats {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 2px 12px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.cats .el-segmented {
  flex-shrink: 0;
}

.count {
  font-size: 12px;
  color: #909399;
  margin-left: auto;
  white-space: nowrap;
  flex-shrink: 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  align-items: stretch;
}

.empty-block {
  grid-column: 1 / -1;
}

.tool-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px;
  border: 1px solid #eef0f5;
  transition: transform .2s, box-shadow .2s;
  display: flex;
  flex-direction: column;
  min-width: 0;
  cursor: pointer;
}

.tool-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 26px rgba(50, 70, 180, .12);
  border-color: var(--c);
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}

.icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
  padding: 0;

  :deep(.el-icon) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1;
  }
}

.tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 0;
}

.title {
  margin: 0 0 6px;
  font-size: 15px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin: 0 0 12px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 42px;
}

.foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: auto;
}

.meta {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.meta-txt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.use-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--c);
  cursor: pointer;
  padding: 6px 2px;
  user-select: none;

  .go {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--c);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: transform .2s;
  }

  &:hover .go {
    transform: translateX(3px);
  }
}

.pager {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

@media (max-width: 900px) {
  .hero {
    flex-direction: column;
    align-items: stretch;
  }

  .hero-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .hero-actions {
    max-width: none;
  }
}
</style>
